import { reportUnexpectedClientFailure } from '@/shared/lib/reportUnexpectedClientFailure'

export const ENG_2178_SENTRY_PROBE_QUERY_PARAM = 'sentry_probe'
export const ENG_2178_SENTRY_PROBE_VALUE = 'eng-2178'

let eng2178ProbeReported = false

export function maybeReportEng2178ProductionProbe(args: {
  isArtemAdmin: boolean
  probeValue: string | null
}): void {
  if (!args.isArtemAdmin) {
    return
  }

  if (args.probeValue !== ENG_2178_SENTRY_PROBE_VALUE) {
    return
  }

  if (eng2178ProbeReported) {
    return
  }

  eng2178ProbeReported = true

  reportUnexpectedClientFailure({
    error: new Error('ENG-2178 production probe'),
    severity: 'crash',
  })
}
